import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import routes from "~react-pages";

const queryClient = new QueryClient();

function App(): JSX.Element {
  return (
    <Suspense fallback={<p>Loading...</p>}>
      <QueryClientProvider client={queryClient}>{useRoutes(routes)}</QueryClientProvider>
    </Suspense>
  );
}

export default App;
